
import { createRouter, createWebHistory } from 'vue-router'

// base
import base from './base'
// 新闻
/*import news from './news'
// 文化
import culture from './culture'
// 文化
import huchi from './huchi'*/
import routers from './routers'

export default createRouter ({ 
    history: createWebHistory(),
    routes: [].concat( base, routers)
})